import React from 'react';
import { RawSingleCheckboxInput } from './SingleCheckboxField';

import connectFormComponentToReduxForm from 'utils/connectFormComponentToReduxForm';

// SingleCheckboxField is wrapped with StyledLabelAndError, so the label
// is on the left and the checkbox lines up with other fiels in the form.

// SimpleCheckboxField is not wrapped with StyledLabelAndError, and inserts its
// own label to the right of the checkbox.

const RawSimpleCheckboxField = ({ className, name, meta, label, wrapperProps, ...inputProps }) => (
  <label className={className}>
    <RawSingleCheckboxInput name={name} {...inputProps} /> {label}
  </label>
);

RawSimpleCheckboxField.displayName = 'RawSimpleCheckboxField';

export { RawSimpleCheckboxField };

const SimpleCheckboxField = connectFormComponentToReduxForm(RawSimpleCheckboxField);
SimpleCheckboxField.displayName = 'SimpleCheckboxField';

export default SimpleCheckboxField;
